import { render, staticRenderFns } from "./PDFcreate.vue?vue&type=template&id=643cd28e&scoped=true"
import script from "./PDFcreate.vue?vue&type=script&lang=js"
export * from "./PDFcreate.vue?vue&type=script&lang=js"
import style0 from "./PDFcreate.vue?vue&type=style&index=0&id=643cd28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643cd28e",
  null
  
)

export default component.exports